export enum Status {
  ACCEPTED_RESPONSE = 1,
  ACCEPTED_REQUEST = 1,
  INITIATED = 11,
  CLOSED = 8,
  REJECTED = 16,
  RETURNED = 14,
}

export enum RegistrationStatus {
  Approvato = 0,
  DaRiesaminare = 1,
  Rifiutato = 2,
}
